module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/005toc#acknowledgments"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Bill LeBlond and Amy Treadwell at Chronicle Books, and my literary agent Angela Miller-for helping make this book possible. Thanks for believing in me. And to the rest of the Chronicle Books team: Doug Ogan, Claire Fletcher, Alice Chau, Tera Killip, Peter Perez, and David Hawk, thanks for helping me look good. Thanks also go to copy editor AnnRolke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Dale Dietert and Hank Hammett, two of the most creative, charming, and hospitable Texans I’m blessed to know. And to Pamela Elrod, whose stories of her aunt, Texas Elrod Culver (a.k.a. “Sugah”), and her family’s East Texas farm named Plentywood, set me on my way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my brother Dempse McMullen, and friends Kirk and Joy Kirksey: Hats off for lending us some fab Texas wares for photography")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my SMU colleagues in News & Communications: Thanks for putting up with my sugar rushes and helping me taste-test the goods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To all those featured in the book who let me show off what you can do: Bless you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my mother, Freddie Lee, and father, Johnny–for letting me be born in this great state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my husband, Robert M. Peacock–a sweet soul and talented photographer–and Alfie the wonder dog: Thanks for being at my side.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img-005.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c3456c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004acknowledgments.vue
// module id = 66
// module chunks = 0